import { SavedFiltersIds } from '../../../interfaces/filters';
import { ISavedFilter } from '../../../store/saved_filters/actions';
import { HeatingSourceTypeLongNames } from '../extra_filters/heating_source_type';
import { HouseMaterialLongNames } from '../extra_filters/house_material';
import { OtherCommunicationLongNames } from '../extra_filters/other_communications';
import { ReadyStatusLongNames } from '../extra_filters/ready_status';
import { SaleStatusLongNames } from '../extra_filters/sale_status';
import { WcLocationLongNames } from '../extra_filters/wc_location_type';

export function getItemName(item: ISavedFilter) {
  switch (item.id) {
    case SavedFiltersIds.SaleStatus:
      return SaleStatusLongNames[item.name];
    case SavedFiltersIds.ReadyStatus:
      return ReadyStatusLongNames[item.name];
    case SavedFiltersIds.OtherCommunications:
      return OtherCommunicationLongNames[item.name];
    case SavedFiltersIds.HouseMaterialType:
      return HouseMaterialLongNames[item.name];
    case SavedFiltersIds.HeatingSourceType:
      return HeatingSourceTypeLongNames[item.name];
    case SavedFiltersIds.WcLocationType:
      return WcLocationLongNames[item.name];
    default:
      return item.name;
  }
}
